import './App.css';
import { Footer } from './Footer/Footer';
import { Main } from './Main/Main';
import { Wallet } from './Wallet/Wallet';
import copy from "./assets/copy.png"

const handleCopy = () => {
  const contract = "CubanZGDS1ny9rodw3oUvbL75uTxDXJwFd2uhMyU7G8z";
  navigator.clipboard.writeText(contract);
};

function App() {
  return (
    <>
      <div className="app">
        <Main />
        <Wallet />
        <Footer />
      </div>
      <div className='app_mobile'>
        <span className='app_mobile_title'>MARK CUBAN MEME</span>
        <span className='app_mobile_text'>Desktop only!</span>
        <div className="mobile_contract">
          <div className="mobile_CA">
            {/* <span style={{ fontSize: "20px", fontWeight: "600" }}>CA:</span> */}
            <span onClick={handleCopy} style={{ fontSize: "10.5px", fontWeight: "400" }}>CubanZGDS1ny9rodw3oUvbL75uTxDXJwFd2uhMyU7G8z</span>
          </div>
          <img onClick={handleCopy} style={{ cursor: "pointer" }} src={copy} alt="copy" draggable={false} />
        </div>
      </div>
    </>
  );
}

export default App;
